import { render, staticRenderFns } from "./learningIndex.vue?vue&type=template&id=825375c8&scoped=true"
import script from "./learningIndex.vue?vue&type=script&lang=js"
export * from "./learningIndex.vue?vue&type=script&lang=js"
import style0 from "./learningIndex.vue?vue&type=style&index=0&id=825375c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825375c8",
  null
  
)

export default component.exports